export * from '@src/components/templates/tefOne/forTesting.tmpl.js';
export * from '@src/components/templates/tefOne/TefComs4p/index.js';
export * from '@src/components/templates/tefOne/tefComsCancelButton.tmpl.js';
